import { Component, computed, forwardRef, inject, Injector, input, model, OnInit, signal, TemplateRef, viewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { DxRadioGroupComponent, DxRadioGroupModule, DxTemplateModule } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/radio_group';
import { NgTemplateOutlet } from '@angular/common';
import { DECORATOR_HOST, DecoratorHost } from 'src/app/controls/directives/decorator-host';

@Component({
  selector: 'app-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrl: './radio-button-group.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioButtonGroupComponent),
      multi: true
    },
    {
      provide: DECORATOR_HOST,
      useExisting: forwardRef(() => RadioButtonGroupComponent)
    }
  ],
  imports: [DxRadioGroupModule, DxTemplateModule, NgTemplateOutlet]
})
export class RadioButtonGroupComponent implements OnInit, ControlValueAccessor, DecoratorHost {
  private dx = viewChild.required<DxRadioGroupComponent>('dx');
  private ngControl: NgControl = null;
  private injector = inject(Injector);

  value = model<unknown>(null);
  dataSource = input.required<unknown[]>();
  valueExpr = input<string>(null);
  displayExpr = input<string>(null);
  readonly = input<boolean>(false);
  itemTemplate = input<TemplateRef<{ $implicit: unknown }> | null>(null);

  private readonly inputId = signal<string | null>(null);
  protected readonly inputAttr = computed<Record<string, string>>(() => this.inputId() ? { id: this.inputId() } : {});

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null);
  }

  get control(): AbstractControl {
    return this.ngControl?.control;
  }

  get isValid(): boolean {
    return !this.control || (this.control.invalid !== true || (this.control.pristine && this.control.untouched));
  }

  onValueChanged(e: ValueChangedEvent): void {
    if (e.value !== this.value()) {
      this.onChange(e.value);
      this.value.set(e.value);
    }
  }


  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: string): void {
    this.value.set(obj);
  }

  onChange: (value: unknown) => void = () => { };
  registerOnChange(fn: (value: unknown) => void): void {
    this.onChange = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.dx().disabled = isDisabled;
  }


  /*
   * DecoratorHost interface methods
   */

  setInputId(inputId: string | null): void {
    this.inputId.set(inputId);
  }

  getInputId(): string | null {
    return this.inputId();
  }
}
